(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-logo"] && !Shopify.designMode) return;
  try {
    (function () {
  const logo = document.querySelector('.header-logo');
  if (!logo) return;

  // Tillfälligt avstängd på desktop — sätt till false för att återaktivera
  var FLUID_DISABLED_DESKTOP = true;

  // Avstängd även på mobil: canvasen är fullskärm där (100vw × 100vh — se
  // .logo-fluid-canvas i max-width:749px-blocket i stylesheet-delen ovan), så
  // simuleringen körde över hela skärmen och värmde telefonen.
  // Sätt till false för att återaktivera.
  // Drawer-fluiden berörs inte av den här — den är ett eget script
  // (logo-fluid-drawer.js) och är redan avstängd under 750px i onDrawerOpen().
  var FLUID_DISABLED_MOBILE = true;

  // ── State ──
  var drawerOpen = false;
  var drawerDriftTimer = null;
  var drawerListenerReady = false;

  // ── Canvas positioning (normal/logo mode) ──
  function positionCanvas() {
    if (drawerOpen) return;
    const img = logo.querySelector('.header-logo__image');
    const canvas = document.getElementById('logo-fluid-canvas');
    if (!img || !canvas) return;

    const isMobile = window.innerWidth < 750;

    if (isMobile) {
      canvas.style.left = '0';
      canvas.style.top = '0';
      canvas.style.width = '100vw';
      canvas.style.height = '100vh';
      canvas.style.transform = 'none';
    } else {
      const r = img.getBoundingClientRect();
      const pad = (window.logoFluid && window.logoFluid.config.CANVAS_PADDING) || 90;
      canvas.style.left = (r.left - pad - 200) + 'px';
      canvas.style.width = (r.width + pad * 2 + 400) + 'px';
    }
  }

  function loadFluid() {
    const canvas = document.getElementById('logo-fluid-canvas');
    if (!canvas) return;

    const old = document.getElementById('logo-fluid-script');
    if (old) old.remove();

    window.logoFluid = null;

    const s = document.createElement('script');
    s.id = 'logo-fluid-script';
    s.src = canvas.dataset.src;
    document.head.appendChild(s);
  }

  // ── Drawer: separate canvas + script (logo-fluid-drawer.js) ──
  var logoCanvas = document.getElementById('logo-fluid-canvas');
  var drawerFluidScriptUrl = logoCanvas ? logoCanvas.dataset.drawerSrc : '';

  function createDrawerCanvas() {
    var existing = document.getElementById('drawer-fluid-canvas');
    if (existing) { existing.style.display = ''; return existing; }

    var drawer = document.querySelector('.menu-drawer');
    if (!drawer) return null;

    // Base-layer (underst, z-index 0) — halvtransparant vitt bakom canvas
    if (!drawer.querySelector('.drawer-base-layer')) {
      var base = document.createElement('div');
      base.className = 'drawer-base-layer';
      drawer.insertBefore(base, drawer.firstChild);
    }

    // Canvas (mitten, z-index 1)
    var c = document.createElement('canvas');
    c.id = 'drawer-fluid-canvas';
    c.setAttribute('aria-hidden', 'true');
    c.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;'
      + 'pointer-events:none;z-index:1;opacity:0.95;max-width:none;';
    var baseLayer = drawer.querySelector('.drawer-base-layer');
    if (baseLayer && baseLayer.nextSibling) {
      drawer.insertBefore(c, baseLayer.nextSibling);
    } else {
      drawer.insertBefore(c, drawer.firstChild);
    }

    // Bg-layer (ovanpå canvas, z-index 2) — frosted glass
    if (!drawer.querySelector('.drawer-bg-layer')) {
      var bg = document.createElement('div');
      bg.className = 'drawer-bg-layer';
      drawer.insertBefore(bg, c.nextSibling);
    }
    return c;
  }

  var _drawerFluidLoaded = false;

  function preloadDrawerFluid() {
    if (!drawerFluidScriptUrl) return;
    // Preload script file into browser cache (no WebGL init yet — drawer has no size when closed)
    var link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'script';
    link.href = drawerFluidScriptUrl;
    document.head.appendChild(link);
  }

  function loadDrawerFluid() {
    // Already preloaded: just resume
    if (_drawerFluidLoaded && window.drawerFluid) {
      var c = document.getElementById('drawer-fluid-canvas');
      if (c) { c.style.display = ''; c.style.opacity = '0'; }
      window.drawerFluid.clear();
      window.drawerFluid.resume();
      return;
    }

    // Fallback if preload didn't run
    var old = document.getElementById('drawer-fluid-script');
    if (old) old.remove();
    window.drawerFluid = null;

    var s = document.createElement('script');
    s.id = 'drawer-fluid-script';
    s.src = drawerFluidScriptUrl;
    s.onload = function() { _drawerFluidLoaded = true; };
    document.head.appendChild(s);
  }

  function destroyDrawerFluid() {
    // Pause instead of destroy — keeps WebGL context alive for instant restart
    if (window.drawerFluid) {
      window.drawerFluid.pause();
    }
    var canvas = document.getElementById('drawer-fluid-canvas');
    if (canvas) canvas.style.display = 'none';
  }

  // ── Drawer drift ──
  function startDrawerDrift() {
    stopDrawerDrift();
    function tick() {
      if (!drawerOpen || !window.drawerFluid) return;
      var dc = window.drawerFluid && window.drawerFluid.config;
      if (dc && dc.DRIFT_ENABLED === false) return;
      var x = 0.1 + Math.random() * 0.8;
      var y = 0.1 + Math.random() * 0.8;
      var gx = (dc && dc.DRIFT_GRAVITY_X) || 0;
      var gy = (dc && dc.DRIFT_GRAVITY_Y) || 0;
      var rf = (dc && dc.SPLAT_RANDOM_FORCE) || 300;
      var dx = rf * (Math.random() - 0.5) + gx;
      var dy = rf * (Math.random() - 0.5) + gy;
      window.drawerFluid.splatAtDir(x, y, dx, dy);
      window.drawerFluid.splatAtDir(
        x + 0.08 * (Math.random() - 0.5),
        y + 0.08 * (Math.random() - 0.5),
        dx * 0.8, dy * 0.8
      );
      var dMin = (dc && dc.DRIFT_INTERVAL_MIN) || 2000;
      var dRange = (dc && dc.DRIFT_INTERVAL_RANGE) || 2000;
      drawerDriftTimer = setTimeout(tick, dMin + Math.random() * dRange);
    }
    var startDelay = (window.drawerFluid && window.drawerFluid.config && window.drawerFluid.config.DRIFT_START_DELAY) || 800;
    drawerDriftTimer = setTimeout(tick, startDelay);
  }

  function stopDrawerDrift() {
    if (drawerDriftTimer) { clearTimeout(drawerDriftTimer); drawerDriftTimer = null; }
  }

  // ── Drawer open/close handlers ──
  function onDrawerOpen() {
    if (window.innerWidth < 750) return;
    drawerOpen = true;

    // Create separate drawer canvas + load its own WebGL script
    createDrawerCanvas();
    loadDrawerFluid();

    // Drawer bakgrund = transparent, bg-layer bär färgen
    var drawer = document.querySelector('.menu-drawer');
    if (drawer) {
      drawer.style.setProperty('background-color', 'transparent', 'important');
    }

    // Applicera bg-layer färg från config när scriptet laddats
    function applyBgLayerStyle() {
      var bgLayer = drawer && drawer.querySelector('.drawer-bg-layer');
      if (!bgLayer) return;
      // Let CSS handle the frosted glass styling — don't override with inline styles
    }

    function fireInitialBurst() {
      applyBgLayerStyle();
      startDrawerDrift();
    }

    // If already loaded (resumed), fire immediately; otherwise poll for first load
    if (_drawerFluidLoaded && window.drawerFluid) {
      fireInitialBurst();
    } else {
      var waitForDrawerFluid = setInterval(function () {
        if (!drawerOpen) { clearInterval(waitForDrawerFluid); return; }
        if (window.drawerFluid) {
          clearInterval(waitForDrawerFluid);
          fireInitialBurst();
        }
      }, 50);
    }
  }

  function onDrawerClose() {
    if (!drawerOpen) return;
    drawerOpen = false;
    stopDrawerDrift();

    // Återställ drawer bakgrund
    var drawer = document.querySelector('.menu-drawer');
    if (drawer) {
      drawer.style.backgroundColor = '';
      var bgLayer = drawer.querySelector('.drawer-bg-layer');
      if (bgLayer) {
        bgLayer.style.backgroundColor = '';
      }
    }

    // Tear down the drawer fluid (stops RAF, hides canvas)
    destroyDrawerFluid();
  }

  // ── Drawer listener setup with robust retry ──
  var drawerSetupAttempts = 0;
  function setupDrawerListener() {
    var details = document.getElementById('Details-menu-drawer-container');
    if (!details) {
      drawerSetupAttempts++;
      if (drawerSetupAttempts < 10) {
        setTimeout(setupDrawerListener, 500);
      }
      return;
    }
    var drawer = details.querySelector('.menu-drawer');
    if (!drawer) {
      drawerSetupAttempts++;
      if (drawerSetupAttempts < 10) {
        setTimeout(setupDrawerListener, 500);
      }
      return;
    }
    if (drawerListenerReady) return;
    drawerListenerReady = true;

    // MutationObserver on 'open' attribute AND 'class' changes
    // Shopify's HeaderDrawer component adds 'menu-open' class (may not set 'open' attribute)
    function checkDrawerState() {
      var isOpen = details.hasAttribute('open') || details.classList.contains('menu-open');
      if (isOpen && !drawerOpen) onDrawerOpen();
      else if (!isOpen && drawerOpen) onDrawerClose();
    }

    var observer = new MutationObserver(function () {
      checkDrawerState();
    });
    observer.observe(details, { attributes: true, attributeFilter: ['open', 'class'] });

    // Toggle event as fallback
    details.addEventListener('toggle', function () {
      checkDrawerState();
    });

    // Mouse interaction inside the drawer — queued directional splats synced to RAF
    var prevDrawerX = -1, prevDrawerY = -1;
    drawer.addEventListener('mousemove', function (e) {
      if (!drawerOpen || !window.drawerFluid || !window.drawerFluid.queueSplat) return;
      var dCanvas = document.getElementById('drawer-fluid-canvas');
      if (!dCanvas) return;
      var rect = dCanvas.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;
      var y = 1.0 - (e.clientY - rect.top) / rect.height;
      if (prevDrawerX < 0) { prevDrawerX = x; prevDrawerY = y; return; }
      var diffX = x - prevDrawerX;
      var diffY = y - prevDrawerY;
      var dist = Math.sqrt(diffX * diffX + diffY * diffY);
      prevDrawerX = x;
      prevDrawerY = y;
      if (dist < 0.001) return;
      var dc = window.drawerFluid.config;
      var force = (dc && dc.SPLAT_FORCE) || 6000;
      var dx = diffX * force;
      var dy = diffY * force;
      // Interpolate: queue intermediate splats for fast movements
      var steps = Math.min(Math.ceil(dist / 0.02), 6);
      for (var i = 0; i < steps; i++) {
        var t = (i + 1) / steps;
        var sx = x - diffX * (1 - t);
        var sy = y - diffY * (1 - t);
        window.drawerFluid.queueSplat(sx, sy, dx, dy);
      }
    });
  }

  // Move canvas out of .header-logo <a> tag to escape its transform.
  // A position:fixed element is positioned relative to the nearest transformed
  // ancestor (per CSS spec) — .header-logo has transform:translateY(...), which
  // made the canvas position relative to the centered logo instead of the viewport
  // and caused horizontal page scroll on mobile.
  function detachCanvas() {
    var canvas = document.getElementById('logo-fluid-canvas');
    if (canvas && canvas.parentElement !== document.body) {
      document.body.appendChild(canvas);
    }
  }

  // ── Init ──
  function init() {
    detachCanvas();

    var isMobile = window.innerWidth < 750;

    // Header-logo fluid: avstängd på BÅDA av prestandaskäl (två separata switchar).
    // Drawer-/burgermenyns fluid behålls oavsett — laddas via setupDrawerListener + preloadDrawerFluid.
    if (isMobile ? FLUID_DISABLED_MOBILE : FLUID_DISABLED_DESKTOP) {
      var c = document.getElementById('logo-fluid-canvas');
      if (c) c.style.display = 'none';
      setupDrawerListener();
      // Preload bara på desktop — samma regel som i den aktiva grenen nedan.
      // På mobil öppnar onDrawerOpen() aldrig drawer-fluiden, så en preload där
      // vore en nedladdning utan mottagare.
      if (!isMobile) preloadDrawerFluid();
      return;
    }

    // Grenen nedan körs bara när en switch ovan satts till false.
    var canvas = document.getElementById('logo-fluid-canvas');
    if (canvas) canvas.style.display = '';
    positionCanvas();
    loadFluid();
    setupDrawerListener();
    // Preload drawer fluid WebGL (compiles shaders, then pauses — zero ongoing cost)
    if (window.innerWidth >= 750) preloadDrawerFluid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', positionCanvas);

  // Re-init when restored from bfcache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) init();
  });

  // ── Auto-drift disabled ──

  // ── Mouse interaction (logo mode) ──
  var lastMouseSplat = 0;
  document.addEventListener('mousemove', function (e) {
    if (!window.logoFluid || drawerOpen) return;
    var img = logo.querySelector('.header-logo__image');
    if (!img) return;
    var logoRect = img.getBoundingClientRect();
    var pad = 30;
    // Only trigger if mouse is near the logo image
    if (e.clientX < logoRect.left - pad || e.clientX > logoRect.right + pad || e.clientY < logoRect.top - pad || e.clientY > logoRect.bottom + pad) return;
    var now = Date.now();
    var logoThrottle = (window.logoFluid && window.logoFluid.config && window.logoFluid.config.MOUSEMOVE_THROTTLE) || 60;
    if (now - lastMouseSplat < logoThrottle) return;
    lastMouseSplat = now;
    var canvas = document.getElementById('logo-fluid-canvas');
    var rect = canvas.getBoundingClientRect();
    var x = (e.clientX - rect.left) / rect.width;
    var y = 1.0 - (e.clientY - rect.top) / rect.height;
    window.logoFluid.splatAt(x, y);
  });

  // ── Touch-swipe interaction ──
  var touchStartX = 0;
  var touchStartY = 0;
  var touchStartTime = 0;
  var lastTouchSplat = 0;
  var prevTouchX = 0;
  var prevTouchY = 0;

  document.addEventListener('touchstart', function (e) {
    if (!window.logoFluid) return;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    prevTouchX = touchStartX;
    prevTouchY = touchStartY;
    touchStartTime = Date.now();
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!window.logoFluid) return;
    var now = Date.now();
    if (now - lastTouchSplat < 60) return;
    lastTouchSplat = now;

    var canvas = document.getElementById('logo-fluid-canvas');
    if (!canvas) return;
    var rect = canvas.getBoundingClientRect();

    // Momentant delta sedan förra splatten — INTE ackumulerat från touchstart,
    // annars växer kraften obegränsat under långa scroll-gester.
    var deltaX = e.touches[0].clientX - prevTouchX;
    var deltaY = e.touches[0].clientY - prevTouchY;

    // Föregående + nuvarande position i sim-koordinater (y uppåt)
    var px = (prevTouchX - rect.left) / rect.width;
    var py = 1.0 - (prevTouchY - rect.top) / rect.height;
    var x = (e.touches[0].clientX - rect.left) / rect.width;
    var y = 1.0 - (e.touches[0].clientY - rect.top) / rect.height;

    prevTouchX = e.touches[0].clientX;
    prevTouchY = e.touches[0].clientY;

    // Horisontell kraft något dämpad (0.09) för subtilare sidledes-swipes
    var dx = deltaX * 0.09;
    // Sim-koordinater har y uppåt — flippa dy. Skala även med skärmens
    // aspect ratio (höjd/bredd): på en stående mobil täcker samma fingersträcka
    // en mycket mindre andel av höjden än av bredden, så utan kompensation
    // upplevs vertikala swipes/scrolls klart svagare än horisontella.
    var aspect = rect.height / rect.width;
    var dy = -deltaY * 0.15 * (aspect > 1 ? aspect : 1);

    // Interpolera splats längs svepet — snabba scrollgester hinner flytta
    // fingret långt mellan throttlade events och lämnar annars gluggar i spåret.
    var distX = x - px;
    var distY = y - py;
    var dist = Math.sqrt(distX * distX + distY * distY);
    var steps = Math.min(Math.ceil(dist / 0.05), 6) || 1;
    for (var i = 1; i <= steps; i++) {
      var t = i / steps;
      window.logoFluid.splatAtDir(px + distX * t, py + distY * t, dx, dy);
    }
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!window.logoFluid) return;
    var canvas = document.getElementById('logo-fluid-canvas');
    if (!canvas) return;
    var rect = canvas.getBoundingClientRect();

    var deltaX = e.changedTouches[0].clientX - touchStartX;
    var deltaY = e.changedTouches[0].clientY - touchStartY;
    var deltaTime = Date.now() - touchStartTime;

    var x = (e.changedTouches[0].clientX - rect.left) / rect.width;
    var y = 1.0 - (e.changedTouches[0].clientY - rect.top) / rect.height;

    if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY) && deltaTime < 300) {
      // Dämpad flick-burst (37.5 → 22, 3 → 2 splats) för subtilare sidledes-swipes
      var force = Math.min(Math.abs(deltaX) / 50, 3);
      var dx = deltaX > 0 ? 22 * force : -22 * force;

      window.logoFluid.splatAtDir(x, y, dx, 11 * (Math.random() - 0.5));
      window.logoFluid.splatAtDir(x + 0.05 * (Math.random() - 0.5), y + 0.03 * (Math.random() - 0.5), dx, 11 * (Math.random() - 0.5));
    }
  }, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

})();
